export default "__VITE_ASSET__BCiKnBk8__"